// @flow

import { useCallback } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useHasPermission from '../../../hooks/useHasPermission';
import useIntl from '../../../hooks/useIntl';
import { navigateToUrlWithSelectedPropertyId } from '../../../utils/navigation-helpers';
import messages from '../messages';

export type TourBlockoutsButtonViewModel = {
  isShown: boolean,
  label: string,
  handleClick: () => void,
};

// Shown only to users the Tour Blockouts route lets in: the `tourScheduling`
// flag on and the `property-activity-manage` permission. The flag defaults to
// off, so the button never flashes on while flags load.
const useTourBlockoutsButton = (): TourBlockoutsButtonViewModel => {
  const { tourScheduling = false } = useFlags();
  const canManage = useHasPermission('property-activity-manage');
  const intl = useIntl();

  const handleClick = useCallback(
    () => navigateToUrlWithSelectedPropertyId('/tour-blockouts'),
    [],
  );

  return {
    isShown: tourScheduling && canManage,
    label: intl.formatMessage(messages.title),
    handleClick,
  };
};

export default useTourBlockoutsButton;
